import { render, staticRenderFns } from "./AwardDetailsModal.vue?vue&type=template&id=3cbfbd48&scoped=true&"
import script from "./AwardDetailsModal.vue?vue&type=script&lang=js&"
export * from "./AwardDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./AwardDetailsModal.vue?vue&type=style&index=0&id=3cbfbd48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cbfbd48",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})
